export default __webpack_public_path__ + "static/media/before.1c8cca4a.png";